import { PricingHeader } from './pricing-header';
import { PricingTiers } from './pricing-tiers';
import { PricingFAQ } from './pricing-faq';
import { PricingCTA } from './pricing-cta';

export function PricingPage() {
  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-24">
        <PricingHeader />
        <PricingTiers />
        <PricingFAQ />
        <PricingCTA />
      </div>
    </div>
  );
}